import { Cookie } from '../functions/cookie'
import { GTMProps } from './types'
import { AppContextProps } from '@wap-client/core'

export const GTMEvent = (
  event?: string,
  data?: any,
  app?: AppContextProps,
): GTMProps | null => {
  if (typeof window === 'undefined') return null

  var mainDomain = 'localhost'
  const currentHost = window.location.hostname
  const userInfo = Cookie.get('userInfo') as any

  let pageUrl: URL | null = null

  // Eğer data ve data.page tanımlıysa URL işlemi yap
  if (data?.page) {
    try {
      pageUrl = new URL(data.page)
    } catch (error) {
      console.error('GTMEvent: Geçersiz URL:', data.page)
    }
  }

  const payload: GTMProps = {
    event,
    site_district:
      app && app.tenant?.location ? app.tenant?.location[0].district : null,
    site_city:
      app && app.tenant?.location ? app.tenant?.location[0].city : null,
    site_region:
      app && app.tenant?.location ? app.tenant?.location[0].region : null,
    user_id: userInfo?.sub || null,
    ...data,
  }

  if (pageUrl && pageUrl.hostname.endsWith(`.${currentHost}`)) {
    ;(window as any).dataLayer.push({
      event: 'sub_site_view',
      page: data.page,
    })
  } else if (
    pageUrl &&
    currentHost.endsWith(`.${mainDomain}`) &&
    pageUrl.hostname !== currentHost &&
    pageUrl.hostname === mainDomain
  ) {
    ;(window as any).dataLayer.push({
      event: 'main_view',
      page: data.page,
      title: document.title,
    })
  } else {
    ;(window as any).dataLayer.push(payload)
  }

  if (process.env.NEXT_PUBLIC_ENV === 'development') {
    console.log('GTM:', payload)
  }

  return payload
}
